// src/contexts/token/useTokenDerivatives.ts
/**
 * Hooks for TokenDerivativesContext
 * Separated for Fast Refresh compatibility
 */

import { useContext } from "react";
import { TokenDerivativesContext } from "./TokenDerivativesProvider";
import type { TokenDerivativesContextValue } from "./types";

export function useTokenDerivatives(): TokenDerivativesContextValue {
  const context = useContext(TokenDerivativesContext);
  if (!context) {
    throw new Error("useTokenDerivatives must be used within a TokenDerivativesProvider");
  }
  return context;
}

export function useTokenDerivativesOptional(): TokenDerivativesContextValue | null {
  return useContext(TokenDerivativesContext);
}

